export default __webpack_public_path__ + "static/media/women_laying_down.617c1f7e.jpg";